import { extensions } from '../extensions/Extensions.mjs';
import { DOMPipe } from './DOMPipe.mjs';
import './index.mjs';
export { DOMContainer } from './DOMContainer.mjs';

"use strict";
extensions.add(DOMPipe);

export { DOMPipe };
//# sourceMappingURL=init.mjs.map
